import React from 'react';
import {List, Datagrid, TextField} from 'react-admin';
import {Create, SimpleForm, TextInput, FileInput, FileField} from 'react-admin';
import {TopToolbar, CreateButton, Button, sanitizeListRestProps} from 'react-admin';
import IconEvent from '@material-ui/icons/Event';


const ListActions = ({basePath, ...rest}) => (
  <TopToolbar {...sanitizeListRestProps(rest)}>
      <CreateButton label="Add" basePath={basePath} />
  </TopToolbar>
);

export const FirmwareList = props => {
  console.log(props);
  return (
    <>
      <List title='Hydrant Fleet Management - Firmwares' bulkActionButtons={false} exporter={false} actions={<ListActions />} {...props}>
        <Datagrid isRowSelectable={()=>(false)}>
          <TextField label="Id" source="id" />
          <TextField label="Version" source="version" />
          <TextField label="Description" source="description" />
        </Datagrid>
      </List>
    </>  
  );
};

export const FirmwareCreate = props => (
  <Create {...props}>
      <SimpleForm>
          <TextInput source="description" />
          <FileInput multiple={false} source="files" label="Firmware Image File">
            <FileField source="src" title="title" />
          </FileInput>
      </SimpleForm>
  </Create>
);

  
  